import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpStatusCode} from "@angular/common/http";
import {CustomMessageService, LocalStorageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import {PermissionService} from "projects/store/src/app/services/permission.service";
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageKey, Permission} from "projects/store/src/app/enums";
import {environment} from "../../../../../environments/environment";
import {catchError, forkJoin, map, switchMap, throwError} from "rxjs";

@Component({
  selector: 'app-commission-reports-sales',
  templateUrl: './commission-reports-sales.component.html',
  styleUrls: ['./commission-reports-sales.component.scss']
})
export class CommissionReportsSalesComponent implements OnInit{
  value?: string;
  userId?: string;
  storeID? : string;
  dealerID? : string;
  rol: any;
  moneda: any;
  listStore: any[] = [];
  selectedDate = new Date();
  selectedStore: string | undefined;
  listSalesBrands: any[] = [];
  listPriceRange: any[] = [];
  basicOptionsSales: any;
  basicOptionsPriceRange: any;
  basicDataSales: any;
  basicDataPriceRange: any;
  userData: UserData;
  @Input() year!: number;
  @Input() month!: number;
  @Output() onLisSales = new EventEmitter<any>;
  textColor?: string;
  textColorSecondary?: string;
  surfaceBorder? : string;

  constructor(private commissionsService: CommissionsService,
              private customMessageService: CustomMessageService,
              private permissionService: PermissionService,
              protected utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data);
    this.userId = this.userData.user.id;
    this.storeID = this.userData.store?.id;
    this.dealerID = this.userData.distributor.id;
    this.rol = this.userData.user.role.code;
    this.moneda = environment.global.country.currency;
    this.setDate(this.selectedDate);
  }

  ngOnInit() {
    const documentStyle = getComputedStyle(document.documentElement);
    this.textColor = documentStyle.getPropertyValue('--text-color');
    this.textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    this.surfaceBorder = documentStyle.getPropertyValue('--surface-border');
    if (this.permissionService.checkPermission(Permission['Gestion.Comercial.Reportes.SeleccionTienda'])) {
      this.loadDataCommercial(this.selectedStore);
      this.loadStoreList(this.dealerID);
    }
    this.loadData();
  }
  setDate(date: Date) {
    this.month = new Date(date).getMonth() + 1;
    this.year = new Date(date).getFullYear();
  }
  drawGraphics(labels: any,  dataSets: any){
    return {
      labels: labels,
      datasets: [
        {
          data: dataSets,
          backgroundColor: ['rgba(255, 6, 46, 0.2)', 'rgba(255, 6, 46, 0.2)', 'rgba(255, 6, 46, 0.2)', 'rgba(153, 102, 255, 0.2)'],
          borderColor: ['rgb(255, 6, 46)', 'rgb(255, 6, 46)', 'rgb(255, 6, 46)', 'rgb(255, 6, 46)'],
          borderWidth: 1
        }
      ]
    };
  }
  setGraphOptions(title: string, scaleYTitle: string, scaleXTitle: string){
    return {
      maintainAspectRatio: false,
        aspectRatio: 0.9,
      plugins: {
      title: {
        display: true,
          text: title,
      },
      legend: {
        display: false,
          labels: {
          color: this.textColor,
        }
      }
    },
      scales: {
        y: {
          min: 0,
            max: scaleXTitle === 'Marcas' ? Math.max(...this.listSalesBrands.map(q => q.quantity +1))
              : Math.max(...this.listPriceRange.map(q => q.quantity +1)),
            beginAtZero: true,
            ticks: {
            color: this.textColorSecondary,
              stepSize: 1
          },
          grid: {
            color: this.surfaceBorder,
              drawBorder: false
          },
          title: {
            display: true,
              text: scaleYTitle,
              color: this.textColor,
          }
        },
        x: {
          barThickness: 5,
            ticks: {
            color: this.textColorSecondary
          },
          grid: {
            color: this.surfaceBorder,
              drawBorder: false
          },
          title: {
            display: true,
              text: scaleXTitle,
              color: this.textColor,
          }
        }
      }
    }

  }
  drawPriceRangeGraph(money: string, minMaxLabels: any, dataSetsPriceRange: any){
    const moneda = money;
    return {
      labels: minMaxLabels.map((item: { min: null; max: null; }) => {
        const minimo = item.min !== null ? `${moneda} ${item.min}` : '';
        const maximo = item.max !== null ? `${moneda} ${item.max}` : '';
        if (minimo && maximo) {
          return `${minimo} a ${maximo}`;
        } else if (minimo) {
          return `Mayor a ${minimo}`;
        } else if (maximo) {
          return `Menos de ${maximo}`;
        } else {
          return '';
        }
      }),
      datasets: [
        {
          data: dataSetsPriceRange,
          backgroundColor: ['rgba(255, 6, 46, 0.2)', 'rgba(255, 6, 46, 0.2)', 'rgba(255, 6, 46, 0.2)', 'rgba(153, 102, 255, 0.2)'],
          borderColor: ['rgb(255, 6, 46)', 'rgb(255, 6, 46)', 'rgb(255, 6, 46)', 'rgb(255, 6, 46)'],
          borderWidth: 1
        }
      ]
    };

  }

  loadStoreList(dealerId: any) {
    this.utilService.enablePageLoading();
    const storeList$ = this.commissionsService.getListStoreByDealer(dealerId);
    const salesData$ = storeList$.pipe(
      switchMap((resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.listStore = resp.body.data.list;
          this.selectedStore = this.listStore[0].id;
          return this.loadDataCommercial(this.selectedStore);
        } else {
          this.customMessageService.responseNoticeHandler(resp);
          return throwError('Error fetching store list');
        }
      })
    );
    forkJoin({ storeList: storeList$, salesData: salesData$ }).subscribe({
      next: (result: { storeList: any, salesData: any }) => {
        console.log(result);
      },
      error: (error: any) => {
        console.error(error);
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      },
      complete: () => {
        this.utilService.disablePageLoading();
      }
    });
  }

  loadDataCommercial(storeID: any) {
    return this.commissionsService.getSaleOneStoreByDealer(storeID, this.month, this.year).pipe(
      map((resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.listSalesBrands = resp.body.data.sales.by_brand;
          this.listPriceRange = resp.body.data.sales.by_price_range;
          this.onLisSales.emit(this.listSalesBrands);
          const labelsSales = this.listSalesBrands.map((company: { name: any; }) => company.name);
          const dataSales: number[] = this.listSalesBrands.map((monto: { quantity: number }) => monto.quantity);
          const dataPriceRange: number[] = this.listPriceRange.map((monto: { quantity: number }) => monto.quantity);
          let minMaxValues = this.listPriceRange.map((item: { min: number; max: number | null }) => {
            return { min: item.min, max: item.max };
          });
          this.basicDataSales = this.drawGraphics(labelsSales, dataSales);
          this.basicOptionsSales = this.setGraphOptions('Ventas por marcas', 'Ventas', 'Marcas');
          this.basicDataPriceRange = this.drawPriceRangeGraph(this.moneda, minMaxValues, dataPriceRange);
          this.basicOptionsPriceRange = this.setGraphOptions('Ventas por rango de precios', 'Ventas', 'Rango de precios');
          return resp.body.data;
        } else {
          this.customMessageService.responseNoticeHandler(resp);
          throw new Error('Error fetching sales data');
        }
      }),
      catchError((error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        throw error;
      })
    );
  }

  loadData(){
    this.utilService.enablePageLoading();
    const salesOfUser$ = this.commissionsService.getSalesOfUser(this.userId, this.month, this.year);
    salesOfUser$?.subscribe({
      next:(resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.listSalesBrands = resp.body.data.sales.by_brand;
          this.listPriceRange = resp.body.data.sales.by_price_range;
          this.onLisSales.emit(this.listSalesBrands);
          const labelsSales = this.listSalesBrands.map((company: { name: any; }) => company.name);
          const dataSales: number[] = this.listSalesBrands.map((monto: { quantity: number }) => monto.quantity);
          const dataPriceRange: number[] = this.listPriceRange.map((monto: { quantity: number }) => monto.quantity);
          let minMaxValues = this.listPriceRange.map((item: { min: number; max: number | null }) => {
            return { min: item.min, max: item.max };
          });
          this.basicDataSales = this.drawGraphics(labelsSales, dataSales);
          this.basicOptionsSales = this.setGraphOptions('Ventas por marca', 'Ventas', 'Marcas')
          this.basicDataPriceRange = this.drawPriceRangeGraph(this.moneda, minMaxValues, dataPriceRange);
          this.basicOptionsPriceRange = this.setGraphOptions('Ventas por rango de precios', 'Ventas', 'Rango de precios');
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    })
  }

  onchangeStore(idStore: any){
    this.utilService.enablePageLoading();
    this.commissionsService.getSaleOneStoreByDealer(idStore, this.month, this.year).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.listSalesBrands = resp.body.data.sales.by_brand;
          this.listPriceRange = resp.body.data.sales.by_price_range;
          this.onLisSales.emit(this.listSalesBrands);
          const labelsSales = this.listSalesBrands.map((company: { name: any; }) => company.name);
          const dataSales: number[] = this.listSalesBrands.map((monto: { quantity: number }) => monto.quantity);
          const dataPriceRange: number[] = this.listPriceRange.map((monto: { quantity: number }) => monto.quantity);
          let minMaxValues = this.listPriceRange.map((item: { min: number; max: number | null }) => {
            return { min: item.min, max: item.max };
          });
          this.basicDataSales = this.drawGraphics(labelsSales, dataSales);
          this.basicOptionsSales = this.setGraphOptions('Ventas por marca', 'Ventas', 'Marcas')
          this.basicDataPriceRange = this.drawPriceRangeGraph(this.moneda, minMaxValues, dataPriceRange);
          this.basicOptionsPriceRange = this.setGraphOptions('Ventas por rango de precios', 'Ventas', 'Rango de precios')

        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      }
    })
  }

  onSelectStore(idStore: any){
    console.log(idStore);
    this.utilService.enablePageLoading();
    this.commissionsService.getSalesOfStore(idStore, this.month, this.year).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.listSalesBrands = resp.body.data.sales.by_brand;
          this.listPriceRange = resp.body.data.sales.by_price_range;
          this.onLisSales.emit(this.listSalesBrands);
          const labelsSales = this.listSalesBrands.map((company: { name: any; }) => company.name);
          const dataSales: number[] = this.listSalesBrands.map((monto: { quantity: number }) => monto.quantity);
          const dataPriceRange: number[] = this.listPriceRange.map((monto: { quantity: number }) => monto.quantity);
          let minMaxValues = this.listPriceRange.map((item: { min: number; max: number | null }) => {
            return { min: item.min, max: item.max };
          });
          this.basicDataSales = this.drawGraphics(labelsSales, dataSales);
          this.basicOptionsSales = this.setGraphOptions('Ventas por marcas', 'Ventas', 'Marcas')
          this.basicDataPriceRange = this.drawPriceRangeGraph(this.moneda, minMaxValues, dataPriceRange);
          this.basicOptionsPriceRange = this.setGraphOptions('Ventas por rango de precios', 'Ventas', 'Rango de precios')
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    })
  }

  protected readonly Permission = Permission;
}
